import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { GAMETIME_API_PATH } from 'src/constants/urlPathAndQueryParams';
import axios from '../utils/APIUtils';

export const editModelList = createAsyncThunk(
  'context/editModelList',
  async (args: any, store) => {
    const {
      context: {
        editModelList: { metadata },
      },
    } = store.getState() as RootState;

    const postData = {
      page: metadata.page,
      rows_per_page: metadata.page_limit,
      sort: metadata.sort,
      ...args,
    };
    const response = await axios.get<any>(
      // GAMETIME_API_PATH.editModelList,
      GAMETIME_API_PATH.getAllModels,
      postData
    );
    return response.data;
  }
);

export const modelStageDetails = createAsyncThunk(
  'context/modelStageDetails',
  async (args: any, store) => {
    const {
      context: {
        modelCenterData: { metadata },
      },
    } = store.getState() as RootState;

    const postData = {
      page: metadata.page,
      rows_per_page: metadata.page_limit,
      sort: metadata.sort,
      ...args,
    };
    const response = await axios.post<any>(
      GAMETIME_API_PATH.modelStageDetails,
      postData
    );
    return response.data;
  }
);

export const modelTableauDetails = createAsyncThunk(
  'context/modelTableauDetails',
  async (args: any) => {
    const postData = {
      ...args,
    };

    const response = await axios.post<any>(
      GAMETIME_API_PATH.modelTableauDetails,
      postData
    );
    return response.data;
  }
);

export const modelFeedback = createAsyncThunk(
  'context/modelFeedback',
  async (args: any) => {
    const response = await axios.post(GAMETIME_API_PATH.modelFeedback, args);
    return { ...response.data, answerResponse: args };
  }
);

export const updateModelQuestions = createAsyncThunk(
  'context/updateModelQuestions',
  async (args: any) => {
    const response = await axios.post(
      GAMETIME_API_PATH.updateModelQuestions,
      args
    );
    return response.data;
  }
);

export const updateModelName = createAsyncThunk(
  'context/updateModelName',
  async (args: any) => {
    const response = await axios.post(
      GAMETIME_API_PATH.updateModelName,
      args
    );
    return response.data;
  }
);

export const listModelDetails = createAsyncThunk(
  'context/listModelDetails',
  async (args: any) => {
    const response = await axios.post(
      GAMETIME_API_PATH.stageQuestionDetails,
      args
    );
    return response.data;
  }
);

export const modelStageUpdate = createAsyncThunk(
  'context/modelStageUpdate',
  async (args: any) => {
    const response = await axios.post(
      GAMETIME_API_PATH.updateModelStage,
      args
    );
    return response.data;
  }
);

export const saveTableauResponses = createAsyncThunk(
  'context/saveTableauResponses',
  async (args: any) => {
    const response = await axios.post(
      GAMETIME_API_PATH.saveTableauResponses,
      args
    );
    return response.data;
  }
);

export const saveGandHTableauResponses = createAsyncThunk(
  'context/saveGandHTableauResponses',
  async (args: any) => {
    const response = await axios.post(
      GAMETIME_API_PATH.saveGandHTableauResponses,
      args
    );
    return response.data;
  }
);


export const initialState = {
  modalOpen: false,
  modalUpdateLoading: false,
  modalListDetailsLoading: false,
  modalNameUpdateLoading: false,
  modelStageUpdateLoading:false,

  modelCenterData: {
    metadata: { page: 1, page_limit: 10, total_row_count: 0, sort: {} },
    model_details: [],
    loading: true,
    error: false,
    errorMsg: '',
  },
  editModelList: {
    metadata: { page: 1, page_limit: 10, total_row_count: 0, sort: {} },
    model_details: [],
    loading: true,
    error: false,
    errorMsg: '',
  },
  modelData: {
    showFinished: false,
    current_unique_id: null,
    total_questions: 0,
    total_answered: 0,
    total_unique_keys: 0,
    total_unique_keys_answered: 0,
    next_unique_key: null,
    questions: [],
    loading: false,
    error: false,
    errorMsg: '',
  },
};

export const contextSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    setModalOpen: (state, action) => {
      state.modalOpen = action.payload;
    },
    setCurrentUniqueId: (state, action) => {
      state.modelData.current_unique_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(modelStageDetails.pending, (state) => {
      return {
        ...state,
        modelCenterData: {
          ...state.modelCenterData,
          loading: true,
          error: false,
        },
      };
    });
    builder.addCase(
      modelStageDetails.fulfilled,
      (state, { payload: { metadata, model_details } }) => {
        return {
          ...state,
          modelCenterData: {
            ...state.modelCenterData,
            metadata: { ...state.modelCenterData.metadata, ...metadata },
            model_details: model_details ?? [],
            loading: false,
          },
        };
      }
    );
    builder.addCase(modelStageDetails.rejected, (state) => {
      return {
        ...state,
        modelCenterData: {
          ...state.modelCenterData,
          loading: false,
          error: true,
          errorMsg: 'Something went wrong!',
        },
      };
    });

    builder.addCase(editModelList.pending, (state) => {
      return {
        ...state,
        editModelList: {
          ...state.editModelList,
          loading: true,
          error: false,
        },
      };
    });
    builder.addCase(
      editModelList.fulfilled,
      (state, { payload: { metadata, model_details } }) => {
        return {
          ...state,
          editModelList: {
            ...state.editModelList,
            metadata: { ...state.editModelList.metadata, ...metadata },
            model_details: model_details ?? [],
            loading: false,
          },
        };
      }
    );
    builder.addCase(editModelList.rejected, (state) => {
      return {
        ...state,
        editModelList: {
          ...state.editModelList,
          loading: false,
          error: true,
          errorMsg: 'Something went wrong!',
        },
      };
    });

     builder.addCase(modelTableauDetails.pending, (state) => {
      return {
        ...state,
        modelData: {
          ...state.modelData,
          loading: true,
          error: false,
          showFinished: false,
        },
      };
    });
    builder.addCase(modelTableauDetails.fulfilled, (state, { payload }) => {
      return {
        ...state,
        modelData: {
          ...state.modelData,
          ...payload,
          loading: false,
        },
      };
    });
    builder.addCase(modelTableauDetails.rejected, (state) => {
      return {
        ...state,
        modelData: {
          ...state.modelData,
          loading: false,
          error: true,
          errorMsg: 'Something went wrong!',
        },
      };
    });

    builder.addCase(modelFeedback.pending, (state) => {
      return {
        ...state,
        modelData: { ...state.modelData, loading: true },
      };
    });
    builder.addCase(
      modelFeedback.fulfilled,
      (state, { payload: { answerResponse } }) => {
        const { question_id, user_response } = answerResponse;
        const questionList: any = state.modelData.questions;
        const questionData: any = questionList.find(
          (data: any) => data.question_id === question_id
        );
        const questions: never[] = questionList.map((question: any) =>
          question.question_id === question_id
            ? { ...question, user_response, is_answered: true }
            : question
        );
        const unAnsQuestions = questions.filter(
          ({ is_answered }) => !is_answered
        );
        const showFinished =
        ((questionData?.preferable_resp !== user_response&&(!(questionData?.preferable_resp===""))) ||
        unAnsQuestions.length === 0);

        return {
          ...state,
          modelData: {
            ...state.modelData,
            total_answered: state.modelData.total_answered + 1,
            current_unique_id: showFinished
              ? state.modelData.next_unique_key
              : state.modelData.current_unique_id,
            questions,
            showFinished,
            loading: false,
            error: false,
          },
        };
      }
    );
    builder.addCase(modelFeedback.rejected, (state) => {
      return {
        ...state,
        modelData: {
          ...state.modelData,
          loading: false,
          error: true,
          errorMsg: 'Something went wrong!',
        },
      };
    });

    builder.addCase(updateModelName.pending, (state) => {
      return {
        ...state,
        modalNameUpdateLoading: true,
      };
    });
    builder.addCase(updateModelName.fulfilled, (state) => {
      return {
        ...state,
        modalNameUpdateLoading: false,
      };
    });
    builder.addCase(updateModelName.rejected, (state) => {
      return {
        ...state,
        modalNameUpdateLoading: false,
      };
    });

    builder.addCase(updateModelQuestions.pending, (state) => {
      return {
        ...state,
        modalUpdateLoading: true,
      };
    });
    builder.addCase(updateModelQuestions.fulfilled, (state) => {
      return {
        ...state,
        modalUpdateLoading: false,
      };
    });
    builder.addCase(updateModelQuestions.rejected, (state) => {
      return {
        ...state,
        modalUpdateLoading: false,
      };
    });

    builder.addCase(listModelDetails.pending, (state) => {
      return {
        ...state,
        modalListDetailsLoading: true,
      };
    });
    builder.addCase(listModelDetails.fulfilled, (state) => {
      return {
        ...state,
        modalListDetailsLoading: false,
      };
    });
    builder.addCase(listModelDetails.rejected, (state) => {
      return {
        ...state,
        modalListDetailsLoading: false,
      };
    });

    
    builder.addCase(modelStageUpdate.pending, (state) => {
      return {
        ...state,
        modelStageUpdateLoading: true,
      };
    });
    builder.addCase(modelStageUpdate.fulfilled, (state) => {
      return {
        ...state,
        modelStageUpdateLoading: false,
      };
    });
    builder.addCase(modelStageUpdate.rejected, (state) => {
      return {
        ...state,
        modelStageUpdateLoading: false,
      };
    });

    //
    builder.addCase(saveTableauResponses.pending, (state) => {
      return{
        ...state
      }
    })
    builder.addCase(saveTableauResponses.fulfilled, (state) => {
      return{
        ...state
      }
    })
    builder.addCase(saveTableauResponses.rejected, (state) => {
      return{
        ...state
      }
    })

    //
    builder.addCase(saveGandHTableauResponses.pending, (state) => {
      return{
        ...state
      }
    })
    builder.addCase(saveGandHTableauResponses.fulfilled, (state) => {
      return{
        ...state
      }
    })
    builder.addCase(saveGandHTableauResponses.rejected, (state) => {
      return{
        ...state
      }
    })

  },
});

export const { setModalOpen, setCurrentUniqueId } = contextSlice.actions;

export const getContextModal = (state: RootState) => state.context.modalOpen;
export const getModelEditLoading = (state: RootState) =>
  state.context.modalUpdateLoading;
  export const getModalListDetailsLoading = (state: RootState) =>
  state.context.modalListDetailsLoading;
  export const getModalNameUpdateLoading = (state: RootState) =>
  state.context.modalNameUpdateLoading;
  
export const getModalCenterData = (state: RootState) =>
  state.context.modelCenterData;
export const getEditModelList = (state: RootState) =>
  state.context.editModelList;
export const getModelData = (state: RootState) => state.context.modelData;
export const getModelStageUpdateLoading = (state: RootState) => state.context.modelStageUpdateLoading;

export default contextSlice.reducer;
